import { render } from "./EditSalary.vue?vue&type=template&id=1cacaa84"
import script from "./EditSalary.vue?vue&type=script&lang=js"
export * from "./EditSalary.vue?vue&type=script&lang=js"

import exportComponent from "/home/stagingfloretcollegein/staging.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__